export default __webpack_public_path__ + "static/media/trackinfo_kart.ab68216a.avif";